import React, { type ErrorInfo, type PropsWithChildren } from 'react'

import { isModuleLoadError } from '@fv/client-core'

import { ChatPanelProvider } from '@/features/chat/ChatPanelProvider'
import { MessagesPanelProvider } from '@/features/messages/MessagesPanelProvider'

import { TopNav } from '../TopNav'
import { DefaultError } from './DefaultError'
import { ModuleLoadError } from './ModuleLoadError'

type Props = PropsWithChildren
type State = {
  hasError: boolean
  errorMessage: string | null
}
class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: PropsWithChildren) {
    super(props)

    this.state = {
      hasError: false,
      errorMessage: null,
    }
  }

  static getDerivedStateFromError(error: Error) {
    console.error(error.message)

    return {
      hasError: true,
      errorMessage: error.message,
    }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.log(errorInfo?.componentStack)
  }

  render() {
    if (this.state.hasError) {
      const moduleError = isModuleLoadError(this.state.errorMessage)
      return (
        <div className="App">
          <ChatPanelProvider>
            <MessagesPanelProvider>
              <TopNav />
            </MessagesPanelProvider>
          </ChatPanelProvider>
          {!moduleError && <DefaultError error={this.state.errorMessage} />}
          {moduleError && <ModuleLoadError />}
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
